<template>
  <div>
    <div class="row mb-30">
      <div class="col-12">
        <account-type-tabs selected="colleges" />
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <div class="dashboard-card">
          <loader v-if="!colleges" style="width: 100%" />

          <college-table
            v-else
            :colleges="colleges"
            :sorted-column="sortedColumn"
            :sorted-asc="sortedAsc"
            :on-sort="onSort"
            :send-message="sendMessage"
            :view-college="viewCollege"
            :edit-college="editCollege"
          />

          <pagination
            v-if="count > limit"
            :filtered-count="count"
            :page="page"
            :page-size="limit"
            :on-page-changed="onPageChanged"
          />
        </div>
      </div>
    </div>

    <send-message-modal ref="sendMessageModal" />

    <view-college-modal
      ref="viewCollegeModal"
      :reload-colleges="loadColleges"
    />
  </div>
</template>

<script>
import AdminClient from '@/api/AdminClient';
import Loader from '@/components/Loader.vue';
import SendMessageModal from '@/components/modals/SendMessageModal.vue';
import Pagination from '@/components/Pagination.vue';
import AccountTypeTabs from './components/AccountTypeTabs.vue';
import CollegeTable from './components/CollegeTable.vue';
import ViewCollegeModal from './components/ViewCollegeModal.vue';

export default {
  name: 'SuperAdminColleges',

  components: {
    Loader,
    SendMessageModal,
    Pagination,
    AccountTypeTabs,
    CollegeTable,
    ViewCollegeModal
  },

  props: {
    search: {
      type: String,
      required: true
    },
    csvBus: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      adminClient: new AdminClient(this.$http),
      timeout: null,

      count: 0,
      page: 1,
      limit: 20,
      sortedColumn: 'num_students_registered',
      sortedAsc: false,

      colleges: null
    };
  },

  watch: {
    search() {
      if (this.timeout) {
        clearTimeout(this.timeout);
        this.timeout = null;
      }
      this.timeout = setTimeout(() => this.loadColleges(), 300);
    }
  },

  mounted() {
    this.csvBus.$on('generate', this.generateCsv);
    this.loadColleges();
  },

  destroyed() {
    this.csvBus.$off('generate', this.generateCsv);
  },

  methods: {
    async loadColleges() {
      const offset = (this.page - 1) * this.limit;
      const filters = {};

      if (this.search) {
        filters.search = this.search;
      }

      this.colleges = null;

      const response = await this.adminClient.getSchoolsList(
        filters,
        this.limit,
        offset,
        this.sortedColumn,
        this.sortedAsc
      );

      this.colleges = response.results || [];
      this.count = response.count;
    },

    onSort(id) {
      if (id && id === this.sortedColumn) {
        this.sortedAsc = !this.sortedAsc;
      } else {
        this.sortedColumn = id;
        this.sortedAsc = true;
      }
      this.loadColleges();
    },
    onPageChanged(page) {
      if (page !== this.page) {
        this.page = page;
        this.colleges = null;
        this.loadColleges();
      }
    },

    sendMessage(filters) {
      this.$refs.sendMessageModal.adminShow(filters);
    },
    async viewCollege(college) {
      try {
        college.report = await this.adminClient.getSchoolReport(college.id);
      } catch (e) {
        // ignore
      }
      this.$refs.viewCollegeModal.show(college);
    },
    editCollege(college) {
      this.$router.push({ name: 'edit-college', params: { id: college.id } });
    },

    async generateCsv() {
      const filters = {};

      if (this.search) {
        filters.search = this.search;
      }

      try {
        const content = await this.adminClient.getSchoolsListCSV(
          filters,
          this.sortedColumn,
          this.sortedAsc
        );
        this.csvBus.$emit('success', { content, file: 'colleges.csv' });
      } catch (e) {
        this.csvBus.$emit('error', e);
      }
    }
  }
};
</script>
